module.exports = __webpack_public_path__ + "img/robot-hand.8ee59a6d.png";